import { RichTextInput } from "ra-input-rich-text";
import { Datagrid, DateField, EditButton, List, ReferenceField, RichTextField, ShowButton, TextField, useRecordContext } from "react-admin";
import { TagsView } from "../moment";



export function ChildMomentList(props) {
    return (
        <List rowClick="show" {...props}>
            <Datagrid>
                <ReferenceField source="childId" reference="child" >
                    <TextField source="name" />
                </ReferenceField>
                <TextField source="type" />
                <MomentName source="momentName" />
                <DateField source="momentTime" showTime />
                <TagsView source="tags" />
                <ShowButton />
                <EditButton />
            </Datagrid>
        </List>
    );
}


export function MomentName() {
    const record = useRecordContext();

    if (record.type === "custom") {
        return <TextField source="momentName" />
    } else {
        return <ReferenceField source="momentId" reference="moment" >
            <TextField source="name" />
        </ReferenceField>
    }
}








